import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'text', 'value'];

  connect() {
    // FIXME: rails-ujs に変更したら data-action で登録可能
    $(this.element).on('ajax:success', (_xhr, data, _status) => {
      alertify.success('変更しました');
      const target = this.hasValueTarget ? this.valueTarget : this.textTarget;
      target.textContent = data.val;
      this.changeTextView();
    });

    // FIXME: rails-ujs に変更したら data-action で登録可能
    $(this.element).on('ajax:error', (_xhr, data, _status) => {
      const message = data.responseJSON
        ? data.responseJSON.msg
        : '更新に失敗しました';
      alertify.error(message);
      this.changeTextView();
    });
  }

  changeEditView() {
    this.inputTarget.style.display = 'block';
    this.textTarget.style.display = 'none';
  }

  changeTextView() {
    this.inputTarget.style.display = 'none';
    this.textTarget.style.display = 'block';
  }
}
